<template>
    <div class="mb-5 bg-white rounded px-md-5 px-sm-2 pt-4 container-fluid">
        <h2><strong style="color:#1A0054">Tutoriales</strong></h2>
        <small>Texto explicativo sobre la información que encontrará  el usuario en este apartado</small>

        <div class="row mt-4">
            <div class="col-md-6" v-for="(tutorial, index) in tutorials" :key="index">
                <div class="card h-100 tutorial-video-card rounded border-0">
                    <div class="card-body">
                        <h4 class="video-title">{{ tutorial.title }}</h4>
                        <iframe
                            class="incrusted-video"
                            :src="tutorial.url"
                            title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen
                        ></iframe>
                        <p class="mt-3"><b>Detalle de que va a aprender en el video:</b> {{ tutorial.description }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return {
                tutorials: [
                    {
                        title: '¿Cómo descargar mis reportes de uso?',
                        url: 'https://www.youtube.com/embed/o4nLLS_eYaM?si=bCHfgdcoEHCYV7Tx',
                        description: 'Accede a insights clave. Dirígete al menú lateral y elige entre "Usuarios" y "Aprendizaje", dependiendo del reporte que deseas descargar. Haz clic en "Descargar reporte". ¡Analiza datos y mejora estrategias para potenciar tu negocio con Utel X for Business!'
                    },
                    {
                        title: '¿Cómo crear una ruta de aprendizaje?',
                        url: 'https://www.youtube.com/embed/7eNilg2F4A0?si=_SqWLdVClCLZf-hU',
                        description: "Define metas educativas. Navega a 'Aprendizaje', sigue los 4 sencillos pasos para la generación de tu ruta y asigna a tu equipo."
                    },
                    {
                        title: '¿Cómo dar de alta a mis colaboradores?',
                        url: 'https://www.youtube.com/embed/TS78y_6v7bg?si=_EJfQjk5SO4w7YLi',
                        description: "Dirígete a 'Usuarios'. Haz scroll vertical hacia abajo y da clic en 'Descargar plantilla', completa los datos de los usuarios que desees agregar dentro del documento. Finalmente haz clic en 'Subir archivo csv' para completar la carga de tus colaboradores."
                    },
                    {
                        title: 'Ranking de usuarios',
                        url: 'https://www.youtube.com/embed/7oUlTZ-3QF8?si=ikYE6NYc2SdTe1NB',
                        description: "¡Impulsa la competencia positiva! Explora el 'Ranking de Colaboradores' para ver el desempeño destacado. Motiva y reconoce logros dentro de tu equipo en Utel X for Business."
                    },
                ]
            }
        }
    }
</script>
<style>
    .tutorial-video-card{
        background: #E0E2FF4D;
    }

    .tutorial-video-card .incrusted-video{
        width: 100%;
        height: 320px;
    }

    .tutorial-video-card .video-title{
        color: #1A0054;
    }
</style>
